/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-10 16:22:10
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {ParamsLogDOI} from "./api/paramsLogApi";
import ParamsLogService from "./service/paramsLogService";
import './paramsLog.less';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';

@Component({name: 'params-log'})
export default class ParamsLog extends BasicSearchPage<ParamsLogService, ParamsLogDOI.RowDataI, ParamsLogDOI.QueryRowDataParamsI> {

	mn: string = ''

    @override
    renderHead(h) {
        return <div></div>
    }

    
	@override
	loadService () {
		this.service = new ParamsLogService(this)
    }

    stationChange(data: StationListDOI.RowDataI) {
        let item = this.queryFormData.find(i=> i.field === 'component')
        item!.props.searchParams = {mn: data.mn}
        this.searchTable()
    }
    
    mounted() {
        this.mn = this.$route.query.mn;
        Bus.$on(Events.StationChange, this.stationChange);
        this.service.initSearchParams()
		this.searchTable()
    }
    
    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
        this.timeout = null
    }
}